export const shouldShowSatisfactionModal = ({ role, progress = {} }) => {
  const satisfactionModalDate = localStorage.getItem('satisfactionModalDate');

  const hasAccess =
    role === 'client' &&
    progress.subscription &&
    progress.module > 0 &&
    !progress.satisfaction &&
    progress.relapse_risk;

  if (new Date().getTime() > satisfactionModalDate && hasAccess) {
    updateSatisfactionModalDate();
    return true;
  }
};

const updateSatisfactionModalDate = () => {
  let currentDate = new Date();
  let week = 7 * 24 * 60 * 60 * 1000;
  const expired = new Date().setTime(currentDate.getTime() + week);
  localStorage.setItem('satisfactionModalDate', JSON.stringify(expired));
};



// WEBPACK FOOTER //
// ./src/containers/MonthlyCheckIn/utils.js